/* eslint-disable */
const Global= {

}
export default Global;